import { render, staticRenderFns } from "./allLeadsInfo.vue?vue&type=template&id=58bd197c&"
import script from "./allLeadsInfo.vue?vue&type=script&lang=js&"
export * from "./allLeadsInfo.vue?vue&type=script&lang=js&"
import style0 from "./allLeadsInfo.vue?vue&type=style&index=0&id=58bd197c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports